<template>
  <a-spin :spinning="loading">
    <div
      class="homeDetails"
      :style="{
        backgroundImage: 'url(' + bgi + ')',
      }"
    >
      <common-header />
      <div class="container">
        <div class="container-first">{{ title }}</div>
        <!-- 上部分数据 -->
        <div class="top">
          <div class="leftNav">
            <div
              v-for="(item, index) in topList"
              :key="index"
              class="navItem cp"
              :style="{
                visibility:
                  item.categoryDTOS !== null ||
                  bottomList[index].categoryDTOS !== null
                    ? 'visible'
                    : 'hidden',
              }"
              @click="handleTopChange(index)"
            >
              <div v-if="index !== classNum" class="navItem-general">
                {{ item.classLevelName }}
                <div class="EName">{{ item.EName }}</div>
              </div>
              <div v-else class="navItem-selected" :style="{color: `${topClassNameColor}`}">
                {{ item.classLevelName }}
                <div class="EName" :style="{color: `${topEClassNameColor}`}">{{ item.EName }}</div>
              </div>
            </div>
          </div>
          <div
            class="rightContent"
            v-if="
              topList[classNum] &&
              topList[classNum].categoryDTOS &&
              topList[classNum].categoryDTOS[0]
            "
          >
            <div
              class="caption"
              :style="{
                backgroundImage:
                  'url(' + topList[classNum].categoryDTOS[0].longImgUrl + ')',
              }"
            >
              {{ topList[classNum].categoryDTOS[0].catName }}
            </div>
            <div class="list">
              <swiper
                :classLevelId="topList[classNum].categoryDTOS[0].classLevelId"
                :imgList="
                  topList[classNum].categoryDTOS[0].categoryTreeDTO || []
                "
                @goCourseDetails="goCourseDetails"
              ></swiper>
            </div>
          </div>
          <div v-else style="color: #333"></div>
        </div>

        <!-- 下部分数据 -->
        <div class="bottom">
          <div
            class="leftContent"
            v-if="
              bottomList[classNum] &&
              bottomList[classNum].categoryDTOS &&
              bottomList[classNum].categoryDTOS[0]
            "
          >
            <div
              class="caption"
              :style="{
                backgroundImage:
                  'url(' +
                  bottomList[classNum].categoryDTOS[0].longImgUrl +
                  ')',
              }"
            >
              {{ bottomList[classNum].categoryDTOS[0].catName }}
            </div>
            <div class="list">
              <swiper
                :classLevelId="
                  bottomList[classNum].categoryDTOS[0].classLevelId
                "
                :imgList="
                  bottomList[classNum].categoryDTOS[0].categoryTreeDTO || []
                "
                @goCourseDetails="goCourseDetails"
              ></swiper>
            </div>
          </div>
          <div v-else style="color: #333"></div>
          <div class="rightNav">
            <div
              v-for="(item, index) in bottomList"
              :key="index"
              class="navItem cp"
              :style="{
                visibility:
                  item.categoryDTOS !== null ||
                  topList[index].categoryDTOS !== null
                    ? 'visible'
                    : 'hidden',
              }"
              @click="handleBottomChange(index)"
            >
              <div v-if="index !== classNum" class="navItem-general">
                {{ item.classLevelName }}
                <div class="EName">{{ item.EName }}</div>
              </div>
              <div v-else class="navItem-selected" :style="{color: `${bottomClassNameColor}`}">
                {{ item.classLevelName }}
                <div class="EName" :style="{color: `${bottomEClassNameColor}`}">{{ item.EName }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-spin>
</template>

<script>
import imagePath from "@/utils/imagePath";
import { getHomeDetails, queryCategoryName } from "@/api/home";
import CommonHeader from "@/components/header/index";
import { mapState } from "vuex";
import swiper from "./components/swiper.vue";
import { codefans_net_CC2PY } from "@/utils/pinYin";
import "@/assets/fonts.less";
import { getColorByClassNum } from "@/utils/getColor";

export default {
  name: "HomeDetails", // 首页详情
  components: {
    CommonHeader,
    swiper
  },
  data() {
    // this.$route.query.parentId 一级学科id
    return {
      imagePath,
      detailsData: {}, // 详情对象 整体结构：[{学段,[{二级学科,[{课程}]}]}]
      classNum: 1, // 课程索引 0托班 1小班 2中班 3大班
      firSubListData: [], // 一级学科列表
      topList: [],
      bottomList: [],
      loading: false,
      title: "",
      // 索引 4 之前的都是老课程
      categoryIndex: 0
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.user.userInfo
    }),
    topClassNameColor() {
      if(this.categoryIndex < 4) {
        return this.getColorByClassNum(this.classNum).selected
      } else {
        switch (this.classNum) {
          case 1:
            return '#EB9753';
          case 2:
            return '#75C5DB';
          case 3:
            return '#F4A0C4';
          default:
            return '';
        }
      }
    },
    topEClassNameColor() {
      if(this.categoryIndex < 4) {
        return this.getColorByClassNum(this.classNum).select
      } else {
        switch (this.classNum) {
          case 1:
            return '#F4C6A1';
          case 2:
            return '#B8F0FF';
          case 3:
            return '#FFD0E4';
          default:
            return '';
        }
      }
    },
    bottomClassNameColor() {
      if(this.categoryIndex < 4) {
        return this.getColorByClassNum(this.classNum).selected
      } else {
        switch (this.classNum) {
          case 1:
            return '#EB9753';
          case 2:
            return '#75C5DB';
          case 3:
            return '#F4A0C4';
          default:
            return '';
        }
      }
    },
    bottomEClassNameColor() {
      if(this.categoryIndex < 4) {
        return this.getColorByClassNum(this.classNum).select
      } else {
        switch (this.classNum) {
          case 1:
            return '#F4C6A1';
          case 2:
            return '#B8F0FF';
          case 3:
            return '#FFD0E4';
          default:
            return '';
        }
      }
    },
    bgi() {
      if(this.categoryIndex < 4) {
        switch (this.classNum) {
          case 0:
            return this.imagePath.class0;
          case 1:
            return this.imagePath.class1;
          case 2:
            return this.imagePath.class2;
          case 3:
            return this.imagePath.class3;
          default:
            return this.imagePath.class0;
        }
      } else {
        switch (this.classNum) {
          case 0:
            return this.imagePath.class0;
          case 1:
            return this.imagePath.class0;
          case 2:
            return this.imagePath.class2;
          case 3:
            return this.imagePath.class3;
          default:
            return this.imagePath.class0;
        }
      }
    }
  },
  async created() {
    await this.queryCategoryName();
    await this.getHomeDetails();
    const index = this.handleSelectIndex();
    this.classNum = sessionStorage.getItem("classNum") * 1 || index;
    sessionStorage.setItem("classNum", this.classNum);
  },
  watch: {
    classNum(val) {
      sessionStorage.setItem("classNum", val);
    }
  },
  methods: {
    getColorByClassNum,
    // 跳转到课程详情
    goCourseDetails(id) {
      this.$router.push({
        path: "/courseDetails",
        query: { id: id, classNum: this.classNum }
      });
    },
    // 切换下部分的右侧导航栏
    handleBottomChange(val) {
      this.classNum = val;
    },
    // 切换上部分的左侧导航栏
    handleTopChange(val) {
      this.classNum = val;
    },
    // 添加英文学段
    toEnglish() {
      this.detailsData.forEach((item) => {
        item.EName = codefans_net_CC2PY(item.classLevelName);
      });
    },
    // 拆分数据    根据数组的索引把数据拆分上、下部分数据
    splitData() {
      this.detailsData.forEach((item, index) => {
        if (index % 2 === 0) {
          this.topList.push(item);
        } else {
          this.bottomList.push(item);
        }
      });
      // console.log(this.topList, "topList");
    },
    // 选出第一个有课程的年级索引
    handleSelectIndex() {
      let index = 0;
      for (let i = 0; i < 4; i++) {
        if (
          this.detailsData[2 * i].categoryDTOS !== null ||
          this.detailsData[2 * i + 1].categoryDTOS !== null
        ) {
          index = i;
          return index;
        }
      }
    },
    // 获取首页详情数据
    async getHomeDetails() {
      if (!this.$route.query || !this.$route.query.id) {
        await this.$router.replace("/home");
        return;
      }
      this.loading = true;
      const { data, status, msg } = await getHomeDetails(this.$route.query.id);
      if (status === 200) {
        console.log(data, "detailsData");
        this.detailsData = data;
        this.splitData();
        this.toEnglish();
      } else {
        this.$message.error(msg);
      }
      this.loading = false;
    },
    async queryCategoryName() {
      this.loading = true;
      const { status, data, msg } = await queryCategoryName(0);
      if (status === 200) {
        this.firSubListData = data;
        this.categoryIndex = this.firSubListData.findIndex(item => item.catId === Number(this.$route.query.id));
        this.title = this.firSubListData[this.categoryIndex].catName;
      } else {
        this.$message.error(msg);
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="less" scoped>
.homeDetails {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  // overflow: hidden;
  .container {
    margin: 0 auto;
    width: 1200px;
    height: 100%;

    &-first {
      margin-top: 24px;
      height: 75px;
      font-size: 58px;
      font-family: YouSheBiaoTiHei;
      color: #333333;
      line-height: 75px;
    }

    .title {
      margin-top: 24px;
      // margin-left: 29px;
      width: 1200px;
      height: 43px;
      background-repeat: no-repeat;
      background-size: cover;
    }

    .top {
      display: flex;
      margin-left: 50px;
      margin-top: 78px;
      width: 1150px;

      .leftNav {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 250px;
        height: 306px;

        .navItem {


          &-general {
            font-size: 20px;
            color: #333;
            font-weight: 600;

            .EName {
              font-size: 16px;
              color: #999;
              font-weight: normal;
            }
          }

          &-selected {
            font-size: 44px;
            font-family: YouSheBiaoTiHei, serif;
            line-height: 57px;

            .EName {
              margin-top: -17px;
              height: 31px;
              font-size: 24px;
              font-family: YouSheBiaoTiHei;
              line-height: 31px;
            }
          }
        }

        .navItemImg {
          width: 234px;
          height: 71px;
          object-fit: cover;
        }
      }

      .rightContent {
        display: flex;
        flex-direction: column;
        align-items: flex-end;

        .caption {
          padding-left: 30px;
          width: 890px;
          height: 78px;
          line-height: 90px;
          font-size: 24px;
          color: #333333;
          font-weight: 550;
          box-sizing: border-box;
          background-size: cover;
          background-repeat: no-repeat;
          border-radius: 10px;
        }

        .list {
          margin-top: 36px;
          width: 900px;
          height: 150px;
        }
      }
    }

    .bottom {
      display: flex;
      justify-content: space-between;
      margin-top: 79px;
      margin-right: 50px;
      padding-bottom: 130px;
      width: 1150px;

      .leftContent {
        .caption {
          padding-left: 30px;
          width: 900px;
          height: 78px;
          line-height: 90px;
          font-size: 24px;
          font-weight: 550;
          color: #333333;
          box-sizing: border-box;
          background-size: cover;
          background-repeat: no-repeat;
        }

        .list {
          margin-top: 36px;
          width: 900px;
          height: 150px;
        }
      }

      .rightNav {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 250px;
        height: 306px;

        .navItem {
          text-align: right;

          &-general {
            font-size: 20px;
            color: #333;
            font-weight: 600;

            .EName {
              font-size: 16px;
              color: #999;
              font-weight: normal;
            }
          }

          &-selected {
            font-size: 44px;
            font-family: YouSheBiaoTiHei, serif;
            line-height: 57px;

            .EName {
              margin-top: -17px;
              height: 31px;
              font-size: 24px;
              font-family: YouSheBiaoTiHei;
              line-height: 31px;
            }
          }
        }

        .navItemImg {
          width: 234px;
          height: 71px;
          object-fit: cover;
        }
      }
    }
  }
}
</style>
